import React from "react";
import LoginForm from "../../LoginForm/LoginForm";
import mainlogo from "../../../assets/logoGoldMaq.jpg";

import "./LoginPage.scss";
const LoginPage = () => {
    return (
        <div className="wrapper-login-page">
            <img src={mainlogo} alt="" />
            <div className="wrapper-login-page__form">
                <LoginForm />
            </div>
        </div>
    );
};

export default LoginPage;
